"use strict";
// @ts-ignore
try {
    self['workbox:routing:7.4.0'] && _();
}
catch (e) { }
